import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NeedHelpService {

  getTelLink(content: string | undefined | null): string | null {
    if (!content) {
      return null;
    }

    const parenMatch = content.match(/\(([\d][\d\s.\-]*\d)\)/);
    if (parenMatch) {
      const digits = parenMatch[1].replace(/\D/g, '');
      if (digits.length >= 3) {
        return this.toTelUri(digits);
      }
    }

    const phoneMatch = content.match(/(?:\+?1[-.\s]?)?(\d{3})[-.\s]?(\d{3})[-.\s]?(\d{4})/);
    if (phoneMatch) {
      return `tel:+1${phoneMatch[1]}${phoneMatch[2]}${phoneMatch[3]}`;
    }

    if (/\b9[-.\s]?8[-.\s]?8\b/.test(content)) {
      return 'tel:988';
    }

    if (/\b9[-.\s]?1[-.\s]?1\b/.test(content) || /\b911\b/.test(content)) {
      return 'tel:911';
    }

    return null;
  }

  private toTelUri(digits: string): string {
    if (digits.length === 3) {
      return `tel:${digits}`;
    }
    if (digits.length === 10) {
      return `tel:+1${digits}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
      return `tel:+${digits}`;
    }
    return `tel:${digits}`;
  }
}
